module.exports = "<h1 class=\"page-header\">Historique des transactions</h1>"